<div class="delete-confirmation-message">
  {{ data.message }}
</div>
